import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../_services';
import {User} from '../_model';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private authenticationService: UserService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user: User = this.authenticationService.currentUserValue;
    if (user) {
      if (state.url !== '/on-boarding') {
        this.router.navigate([state.url]);
      }
      this.router.navigate(['./map']);
      return true;
    }
    return true;
  }
}
